import { useEffect, useState } from "react";
import { apiClient } from "../App";

export default function ScopeIndicator() {
  const [scope, setScope] = useState(null);
  useEffect(() => {
    let cancelled = false;
    apiClient.get("/me/scope").then(res => { if (!cancelled) setScope(res.data); }).catch(() => {});
    return () => { cancelled = true; };
  }, []);
  if (!scope) return null;
  const label = scope.scopeLabel || scope.role || "owner";
  const downstream = scope.unrestricted
    ? `${scope.downstreamCount} fundraisers`
    : `${scope.downstreamCount} downstream`;
  const pillClass = scope.unrestricted
    ? "bg-slate-100 text-slate-700 border-slate-200"
    : "bg-indigo-50 text-indigo-700 border-indigo-200";
  return (
    <div
      className={`inline-flex items-center gap-2 text-xs px-2.5 py-1 rounded-full border ${pillClass}`}
      data-testid="scope-indicator"
      title={scope.unrestricted ? "Viewing all organisation data" : "Scoped to your reporting subtree"}
    >
      <span className="font-medium capitalize">Viewing as: {label}</span>
      <span className="opacity-70">· {downstream}</span>
    </div>
  );
}
